// Brand constants for SHRS (Sarika HR Solutions)
export const BRAND = {
  short: 'SHRS',
  full: 'Sarika HR Solutions',
  tagline: 'Agency Operating System',
  logoUrl: 'https://customer-assets-39nsmqrw.emergentagent.net/job_recruit-hub-321/artifacts/h966s37p_ChatGPT%20Image%20Aug%2012%2C%202025%2C%2001_14_47%20PM.png',
};
